/*
 * @Author: hewuchang
 * @Date:   2018-08-27 18:13:52
 * @Last Modified by:   Hwc
 * @Last Modified time: 2019-02-22 16:39:14
 * @description 工具类合集
 */
import qs from 'qs'
import Utils from './utils';
import { saveLogInfo } from '@/apis/logInfo';
export * from './format';
export * from './encryption';
export { v4 as uuid } from 'uuid';
const TIMEDIFF = 30
export const slice = Array.prototype.slice;
export const toArray = target => {
  return slice.call(target);
};
export { default as waterMarker } from './water-marker';
// 求两个数组的差集.
export const differenceSetOfArray = (baseArray = [], comparisonArray = []) => {
  let cSet = new Set(comparisonArray);
  return Array.from(new Set(baseArray.filter(x => !cSet.has(x))));
};

export const typeOf = obj => {
  return Object.prototype.toString.call(obj).slice(8, -1);
};

export const isEmptyObject = obj => {
  return !!(Object.keys(obj).length) === false;
};

export const toLowerCase = str => {
  return str.toLowerCase();
};

export const firstUpperCase = str => {
  return str.charAt(0).toLocaleUpperCase() + str.slice(1);
};
export const escapeHtml = unsafe => {
  return unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}
export const isUndefined = val => val === undefined;

const uEvent = event => {
  // event.target = event.target || event.srcTarget;
  return event;
};

export const isPlainObject = (obj) => {
  if (typeof obj !== 'object' || obj === null) return false
  let proto = obj
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto)
  }
  // proto = null
  return Object.getPrototypeOf(obj) === proto
}
export const convertOption = (options = []) => {
  if (options.length === 0) return [];
  return options.map(option => {
    if (typeof option === 'object') {
      return {
        ...option
      };
    }
    return {
      value: option,
      label: option
    }
  });
}
export const collectionPackageDeepenOne = matches => {
  let packageObj = {};
  matches.keys().forEach(key => {
    let keys = key.split('/');
    let obj = packageObj[keys[1]] || (packageObj[keys[1]] = {});
    obj[keys[2].slice(0, -3)] = matches(key).default;
  });
  return packageObj;
};
// 深层次遍历某个对象列表， 可以喊某个children属性无限遍历.
export const walkList = (start, {
  childrenProp = 'children',
  itemCallBack = () => { },
  brokenFunc = () => { }
}) => {
  let children;
  if (Array.isArray(start)) {
    children = start;
  } else if (typeOf(start) === 'Object') {
    children = [start];
  }
  while (children.length !== 0) {
    let nextChildren = [];
    children.forEach(item => {
      if (brokenFunc(item)) return;
      itemCallBack(item);
      nextChildren = nextChildren.concat(item[childrenProp] || []);
    });
    children = nextChildren;
  }
}
function dealWithPreResult(args, preResult, config) {
  if (config === undefined) return args;
  const deal = {
    merge(args, preResult) {
      return args.concat(preResult);
    },
    race(args, preResult) {
      args.push(preResult[0]);
      return args;
    },
    replace(args, preResult) {
      return preResult;
    }
  }
  return deal[config](args, preResult);
}
export function createHandlerOfEventByConfig(wholeConfig) {
  return function handlerOfEvent(config) {
    config = config || wholeConfig;
    return async function (...args) {
      let result;
      for (let i = 0, len = (config.precondition || []).length; i < len; i++) {
        let preConfig = config.precondition[i];
        let preResult = await this[preConfig.name](...(preConfig.arguments.map(argConfig => {
          return this.parseArgumentsByConfig.call(this, argConfig);
        }).concat(args)));
        // 处理precondition的执行结果，详细说明参见思维导图
        if (preConfig.dealWithPreResult) {
          args = dealWithPreResult(args, preResult, preConfig.dealWithPreResult);
          console.log(args);
        }
      }
      if (config.name) {
        result = this[config.name](...config.arguments.map(argConfig => {
          return this.parseArgumentsByConfig.call(this, argConfig);
        }).concat(args));
      }
      if (result && result.then) {
        result.then((...args) => {
          config.children && config.children.forEach(config => {
            handlerOfEvent(config).apply(this, args);
          });
        })
      } else {
        config.children && config.children.forEach(config => {
          handlerOfEvent(config).apply(this);
        });
      }
    }
  }
}
export function parseFunction(func) {
  if (typeOf(func) === 'Function') return func;
  if (typeOf(func) === 'Object') {
    return createHandlerOfEventByConfig(func)();
  }
}

// 遍历子节点，根据callback对子节点做对应的操作。
export function loopChildren(children, callback) {
  children.forEach(item => {
    // 为处理narrowBroad组件的二维数组而添加的判断
    if (Array.isArray(item) && item.length > 0) {
      loopChildren(item, callback)
    }
    callback(item);
    if (Array.isArray(item.props?.children) && item.props.children.length > 0) {
      loopChildren(item.props.children, callback);
    }
  });
}

export function urlSearchParams() {
  return new URLSearchParams(document.location.search.substring(1));
}

export const replaceName = (name = '', type = 'editor') => {
  const pre = type === 're' ? 'LcRe' : 'Lc'
  return pre + name
}
// 对物料进行分类处理
export const getMaterialObj = (list = [], type = 'editor') => {
  const material = {}
  list.forEach((item,) => {
    const { className, classLabel, componentName, factoryName } = item
    const newfac = replaceName(factoryName || componentName, type)
    const newComp = replaceName(componentName, type)
    if (material[className]) {
      const { componentList } = material[className]
      material[className] = {
        ...material[className],
        componentList: [
          ...componentList,
          {
            ...item,
            factoryName: newfac,
            componentName: newComp
          }
        ]
      }
    } else {
      material[className] = {
        name: className,
        label: classLabel,
        componentList: [
          {
            ...item,
            factoryName: newfac,
            componentName: newComp
          }
        ]
      }
    }
  })
  return material
}
// 值是否包含 '', null, undefined
export function isExit(value) {
  return ['', null, undefined].includes(value);
}
export const getAppIdByUrl = () => {
  const { appId } = window.location.search ? qs.parse(window.location.search.substr(1)) : {}
  return appId
}
// 通过地址获取路由参数
export const getRouterData = () => {
  const routerData = window.location.search ? qs.parse(window.location.search.substr(1)) : {}
  return routerData
}

/**
 * @description: 样式的白名单数据
 * @return {*}
 */
export const styleWhiteList = ['--borderWidthValue', '--borderWidthUnit', '--borderRadiusValue', '--borderRadiusUnit', '--borderWidthValue', '--borderWidthUnit', '--lineHeightValue', '--lineHeightUnit', '--fontSizeValue', '--fontSizeUnit', '--weightQuickBold', '--weightBoldNumber', '--letterSpaceValue', '--letterSpaceUnit', '--heightValue', '--heightUnit', '--maxHeightValue', '--maxHeightUnit', '--widthValue', '--widthUnit', '_boxShadowBlur', '--boxShadowBlurValue', '--boxShadowBlurUnit', '_boxShadowOffsetY', '--boxShadowOffsetYValue', '--boxShadowOffsetYUnit', '_boxShadowPosition', '_boxShadowSpread', '--boxShadowSpreadValue', '--boxShadowSpreadUnit', '_boxShadowOffsetX', '--boxShadowOffsetXValue', '--boxShadowOffsetXUnit', '_boxShadowColor', '--formInputWidthValue', 'formInputWidthUnit', '--backgroundPositionXQuick', '--backgroundPositionXValue', '--backgroundPositionXUnit', '--backgroundPositionYQuick', '--backgroundPositionYValue', '--backgroundPositionYUnit', '--backgroundSizeQuick', '--backgroundSizeXValue', '--backgroundSizeXUnit', '--backgroundSizeYValue', '--backgroundSizeYUnit'];

// export const styleWhiteList = ['--borderWidthValue', '--borderWidthUnit', '--borderRadiusValue', '--borderRadiusUnit', '--borderWidthValue', '--borderWidthUnit', '--lineHeightValue', '--lineHeightUnit', '--fontSizeValue', '--fontSizeUnit', '--weightQuickBold', '--weightBoldNumber', '--letterSpaceValue', '--letterSpaceUnit', '--heightValue', '--heightUnit', '--maxHeightValue', '--maxHeightUnit', '--widthValue', '--widthUnit', '_boxShadowBlur', '--boxShadowBlurValue', '--boxShadowBlurUnit', '_boxShadowOffsetY', '--boxShadowOffsetYValue', '--boxShadowOffsetYUnit', '_boxShadowPosition', '_boxShadowSpread', '--boxShadowSpreadValue', '--boxShadowSpreadUnit', '_boxShadowOffsetX', '--boxShadowOffsetXValue', '--boxShadowOffsetXUnit', '_boxShadowColor', '--formInputWidthValue', 'formInputWidthUnit','--backgroundPositionXQuick','--backgroundPositionXValue','--backgroundPositionXUnit','--backgroundPositionYQuick','--backgroundPositionYValue','--backgroundPositionYUnit','--backgroundSizeQuick','--backgroundSizeXValue','--backgroundSizeXUnit','--backgroundSizeYValue','--backgroundSizeYUnit'];

/**
 * @description: 样式json 需要去除白名单的json数据
 * @param {*} reStyles
 * @return {*} 已去除白名单的json数据
 */

export const restylesWhiteList = (reStyles) => {
  if (!reStyles || JSON.stringify(reStyles) == '{}') {
    return reStyles
  }
  const reStylesClone = { ...reStyles };
  styleWhiteList.map((item) => {
    if (reStylesClone && Reflect.has(reStylesClone, item)) {
      Reflect.deleteProperty(reStylesClone, item)
    }
  })
  let obj = {}
  Object.keys(reStylesClone).map((key) => {
    const reKey = key.replace("--", "");
    const value = reStylesClone[key];
    obj[reKey] = value;
  })
  return JSON.stringify(obj) == '{}' ? '' : obj;
}

/**
 * @description: 过滤组件的白名单数据
 * @return {*}
 */
export const filterComponentList = ['LayoutBackGauge', 'Dialog', 'Collapse', 'FormItem', 'LayoutBackGauge', 'Switch', 'Tag', 'MultiLineEdit', 'Slider', 'ColorPicker', 'ColorGradient', 'Transfer', 'RadioCard', 'SelectionTable', 'Descriptions']



/**
 * @description: 拼接好展示的样式数组
 * @param {*} styleUnitArr 传递过滤需要展示样式数组，不传使用默认
 * @param {*} defaultStyleUnitArr 默认样式数组
 * @return {*} 返回拼接好最后的样式数组 界面展示
 */
export const styleUnit = (styleUnitArr) => {
  const defaultStyleUnitArr = ['px', '%', 'rem', 'em', 'pt', 'vh', 'vm'];
  let arr = (styleUnitArr ? styleUnitArr : defaultStyleUnitArr).reduce((arr, item) => {
    return arr.concat([{ label: item, value: item }])
  }, [])
  return arr
}

export const setAppUserTokenToSession = () => {
  const { token } = window.location.search ? qs.parse(window.location.search.substr(1)) : {}
  if (token) {
    window.localStorage.setItem('appUserToken', token)
  }

}

// 金额数字大写 最大15位整数 4位小数
export let amountInWords = (money) => {
  //汉字的数字
  let cnNum = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'),
    //基本单位
    cnIntRadices = new Array('', '拾', '佰', '仟'),
    //对应整数部分扩展单位
    cnIntUnits = new Array('', '万', '亿', '兆'),
    //对应小数部分单位
    cnDecUnits = new Array('角', '分', '毫', '厘'),
    //整数金额时后面跟的字符
    cnInteger = '整',
    //整型完以后的单位
    cnIntLast = '元',
    //最大处理的数字
    maxNum = 999999999999999.9999,
    //金额整数部分
    integerNum,
    //金额小数部分
    decimalNum,
    //输出的中文金额字符串
    chineseStr = '',
    minus = '负',
    //分离金额后用的数组，预定义
    parts;
  if (money == '') {
    return '';
  }
  if (money[0] === '-') {
    chineseStr += minus;
    money = money.substr(1);
  }
  money = parseFloat(money);
  if (money >= maxNum) {
    //超出最大处理数字
    return ''
  }
  if (money == 0) {
    chineseStr = cnNum[0] + cnIntLast + cnInteger;
    return chineseStr;
  }
  //转换为字符串
  money = money.toString();
  if (money.indexOf('.') == -1) {
    integerNum = money;
    decimalNum = '';
  } else {
    parts = money.split('.');
    integerNum = parts[0];
    decimalNum = parts[1].substr(0, 4);
  }
  //获取整型部分转换
  if (parseInt(integerNum, 10) > 0) {
    var zeroCount = 0;
    var IntLen = integerNum.length;
    for (var i = 0; i < IntLen; i++) {
      var n = integerNum.substr(i, 1);
      var p = IntLen - i - 1;
      var q = p / 4;
      var m = p % 4;
      if (n == '0') {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNum[0];
        }
        //归零
        zeroCount = 0;
        chineseStr += cnNum[parseInt(n)] + cnIntRadices[m];
      }
      if (m == 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q];
      }
    }
    chineseStr += cnIntLast;
  }
  //小数部分
  if (decimalNum != '') {
    var decLen = decimalNum.length;
    for (var i = 0; i < decLen; i++) {
      var n = decimalNum.substr(i, 1);
      if (n != '0') {
        chineseStr += cnNum[Number(n)] + cnDecUnits[i];
      }
    }
  }
  if (chineseStr == '') {
    chineseStr += cnNum[0] + cnIntLast + cnInteger;
  } else if (decimalNum == '') {
    chineseStr += cnInteger;
  }
  return chineseStr;
}

/**
 * @description: 按照指定的key值拍平多维数组
 * @param {*} arr 需要拍平的数组
 * @param {*} key 桉树组对象对应的key值进行拍平
 * @return { Array } 返回拼接好最后的样式数组
 */
export const flatArrFun = (arr, key) => {
  let newArr = []
  arr.forEach((item) => {
    if (item[key] && item[key].length) {
      newArr = newArr.concat(flatArrFun(item[key], key))
      return
    }
    newArr.push(item)
  })
  return newArr
}

/**
 * @description: 分隔字符串
 * @param {*} str 需要分隔的原字符串，也可以是数字类型
 * @param {*} splitList 分隔方式的数组，如[3, 4, 4]，或者'4'字符按照每4个字符分隔
 * @param {*} type 以什么字符串进行分隔
 * @return {*} 返回分隔后的字符串
 */
export const splitString = (str, split = [], type = ' ') => {
  if (typeof str !== 'string' && typeof str !== 'number') {
    return str;
  }
  const strList = String(str).replace(/\D/g, '').split('');
  let result = [];
  while (strList.length) {
    let splitNum = Array.isArray(split) ? split.shift() : split;
    result.push(strList.splice(0, splitNum || strList.length).join(''));
  }
  return result.join(type);
}
const PATH_MAP={
  'maturityDistribution':'Mem:TermYear:Info',
  'specialProduct':'product:index:list',
  'distributionSituation':'Mem:Dist:Query',
  'businessQualification':'Mem:Qualification:Query'
}
/* 
日志上传处理
*/
export const handleLogInfo = async function(nextPath,beforePath) {
  let reviewTime = Math.floor((Utils.date(this.endTime)-Utils.date(this.startTime))/1000)
  if(reviewTime<10) return
  if(true){
    if(['underwritingStatus','serviceBusiness','underwritingDistribution'].indexOf(beforePath)<0){
      let menuInfo = JSON.parse(localStorage.getItem('MENU_INFO'))||[]
      let params={
        userId:this.userInfo.userId,
        path:PATH_MAP[beforePath],
        name:menuInfo.find(item=>item.perms===PATH_MAP[beforePath])?.['name']||'',
        userName:this.userInfo.userName,
        userOrgName:this.userInfo.userOrgName,
        userOrgId:this.userInfo.userOrgId,
        startTime:this.startTime,
        endTime:this.endTime,
        type:'view',
        description:JSON.stringify({memName:this.memInfo.memName,registerNumber:this.memInfo.registerNumber})
      }
      await saveLogInfo({logInfo:params})
    }else{
    }
  }
}
const tools = {
  slice,
  typeOf,
  uEvent,
  toArray,
  walkList,
  escapeHtml,
  toLowerCase,
  isUndefined,
  convertOption,
  isPlainObject,
  isEmptyObject,
  firstUpperCase,
  collectionPackageDeepenOne,
  createHandlerOfEventByConfig,
}

export default tools;
